<div *ngIf="!loading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="form">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Dados cadastrais do parceiro
				</span>
			</div>
			<div class="d-f mt-xxs mb-xxs">
				<p class="fs-xxs lh-xxs">Selecione os tipos de serviços do parceiro</p>
			</div>
			<div class="d-f mb-xxxs">
				<mat-checkbox color="primary" formControlName="health_plan">
					Plano de saúde
				</mat-checkbox>
				<mat-checkbox
					color="primary"
					class="ml-xs"
					formControlName="dental_plan"
				>
					Plano Dental
				</mat-checkbox>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-2" title="Razão social" appearance="outline">
					<mat-label>Razão social</mat-label>
					<input
						type="text"
						matInput
						placeholder="Razão social"
						formControlName="name"
						id="srs-{{ inputId }}"
					/>
					<mat-error *ngIf="form.get('name')?.hasError('required')">
						É necessário digitar a razão social
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="CNPJ"
					appearance="outline"
				>
					<mat-label>CNPJ</mat-label>
					<input
						type="text"
						matInput
						mask="00.000.000/0000-00"
						placeholder="CNPJ"
						formControlName="cnpj"
						id="spj-{{ inputId }}"
						(blur)="onCnpjBlur()"
					/>
					<mat-error
						*ngIf="
							form.get('cnpj')?.hasError('pattern') &&
							!form.get('cnpj')?.hasError('required') &&
							!form.get('cnpj')?.hasError('minlength')
						"
					>
						Digite um CNPJ válido
					</mat-error>
					<mat-error
						*ngIf="
							form.get('cnpj')?.hasError('minlength') &&
							!form.get('cnpj')?.hasError('pattern') &&
							!form.get('cnpj')?.hasError('required')
						"
					>
						Já existe um parceiro cadastrado com esse CNPJ
					</mat-error>
					<mat-error *ngIf="form.get('cnpj')?.hasError('required')">
						É necessário digitar o CNPJ
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-2"
					title="Nome fantasia"
					appearance="outline"
				>
					<mat-label>Nome fantasia</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome fantasia"
						formControlName="name_secondary"
						id="snf-{{ inputId }}"
					/>
					<mat-error *ngIf="form.get('name_secondary')?.hasError('required')">
						É necessário digitar o nome fantasia
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="Inscrição municipal"
					appearance="outline"
				>
					<mat-label>Inscrição municipal (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Inscrição municipal (opcional)"
						formControlName="municipal_registration"
						id="sim-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Inscrição estadual"
					appearance="outline"
				>
					<mat-label>Inscrição estadual (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Inscrição estadual (opcional)"
						formControlName="state_registration"
						id="sie-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Estado"
					appearance="outline"
				>
					<mat-label>Estado (opcional)</mat-label>
					<mat-select formControlName="state">
						<mat-option [value]="null" (click)="onUFChange(-1)">
							Estado (opcional)
						</mat-option>
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUFChange(s.id)"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field
					class="col-1 mr-xxxs dyn mob-va"
					appearance="outline"
					title="Cidade"
				>
					<mat-label>Cidade (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cidade (opcional)"
						formControlName="city"
						id="sxc-{{ inputId }}"
						*ngIf="!auxStateForm"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm">
						<mat-option [value]="null">Cidade (opcional)</mat-option>
						<mat-option *ngFor="let city of cities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			class="margin-right-16"
			mat-stroked-button
			color="primary"
			(click)="onCancel()"
		>
			Cancelar
		</button>
		<button
			mat-flat-button
			color="primary"
			[disabled]="shouldDisableSaveBtn() || invalidPlans()"
			(click)="onSubmit()"
		>
			{{ partnerId ? 'Salvar' : 'Cadastrar parceiro' }}
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
